import(/* webpackMode: "eager" */ "/home/yardtutor/yardtutor.com/frontend/shared/node_modules/next/dist/client/link.js");
